import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0729b67e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "distribution-page-root main-scroll-topbar-content"
};
const _hoisted_2 = {
  class: "userinfo-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "user-desc"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "part-title basic-info-title"
}, "基本信息", -1));

const _hoisted_6 = {
  class: "basic-info-content"
};
const _hoisted_7 = {
  class: "distribution-user-id"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "分销员ID", -1));

const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  key: 0,
  class: "promotion-code"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "专享优惠码", -1));

const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "bind-experi-at"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "客户绑定有效期", -1));

const _hoisted_15 = {
  class: "content"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "part-title"
}, "售票推广"), /*#__PURE__*/_createElementVNode("div", {
  class: "extendsion-desc"
}, "* 请使用此处海报及链接进行推广，否则无法绑定客户关系")], -1));

const _hoisted_17 = {
  class: "btn-box"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode("生成推广海报");

const _hoisted_19 = {
  class: "operate-btn copy-link"
};

const _hoisted_20 = /*#__PURE__*/_createTextVNode("复制推广链接");

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "part-title total-computed-title"
}, "分销统计", -1));

const _hoisted_22 = {
  class: "total-computed-content"
};
const _hoisted_23 = {
  class: "total-amount"
};

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "销量总金额", -1));

const _hoisted_25 = {
  class: "content"
};

const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "total-amount-remark"
}, "* 销售总金额将在极客公园创新大会 2023 结束后 10 个工作日内完成核算，具体数据以核算为准", -1));

const _hoisted_27 = {
  class: "bind-user-count"
};

const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "累计绑定客户数量", -1));

const _hoisted_29 = {
  class: "content"
};
const _hoisted_30 = {
  class: "user-order-count"
};

const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "累计订单数量", -1));

const _hoisted_32 = {
  class: "content"
};
const _hoisted_33 = {
  class: "user-ticket-count"
};

const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "累计售票数量", -1));

const _hoisted_35 = {
  class: "content"
};

const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "part-title distribution-common-qa"
}, "分销常见问题", -1));

const _hoisted_37 = {
  class: "common-qa-box"
};
const _hoisted_38 = {
  class: "common-question"
};

const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Q：", -1));

const _hoisted_40 = {
  class: "common-answer"
};

const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "A：", -1));

const _hoisted_42 = {
  class: "share-img-wrapper"
};
const _hoisted_43 = ["src"];

const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "long-press-wrapper"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "long-press-tip"
}, "长按上图保存或分享")], -1));

import TopNavigator from "../components/TopNavigator.vue";
import { ref, onBeforeMount } from "vue";
import AV from "../assets/utils/av";
import { jsonify, shareCollectionImg } from "../assets/utils/common.utils";
import dayjs from "dayjs";
import ShareBtn from "../components/ShareBtn.vue";
import { Dialog, Toast } from "vant";
import useClipboard from "vue-clipboard3";
export default {
  __name: 'Distribution',
  props: {},

  setup(__props) {
    const props = __props;
    const {
      toClipboard
    } = useClipboard();
    const VanDialog = Dialog.Component;
    const qas = ref([{
      question: "如何判断分销员授权是否成功？",
      answer: "成为分销员后，您可在个人中心【我的】，访问【分销员个人中心】模块；如未在个人中心找到该模块，请联系 IF2023 工作人员进行核实；如有其他问题，也可随时与 IF 2023 工作人员进行沟通。"
    }, {
      question: "我使用 IF 2023 官网首页、票品详情页面提供的海报和链接进行推广，带来的销售额会计入销售总金额吗？",
      answer: "以上链接均为普通链接，未带有您的个人标识对客户进行关系绑定，因此不会计入您的销售总金额。"
    }, {
      question: "我使用微信右上角“···”处的微信自带分享进行推广，带来的销售额会计入我的销售总金额吗？",
      answer: "此处分享的链接均为普通链接，未带有您的个人标识对客户进行关系绑定，因此不会计入您的销售总金额。"
    }, {
      question: "已与我绑定客户关系的用户，还能被其他分销员绑走吗？",
      answer: "用户与您绑定客户关系后，不可与其他分销员重复绑定关系。在客户绑定有效期内，用户仅能与一名分销员绑定客户关系。"
    }, {
      question: "用户下了单，我这边的“分销统计”数据怎么没变化呢？",
      answer: "请确认用户下单后是否完成支付，仅支付成功的订单，其实付金额会计入“销售总金额”统计；另因技术原因，“分销统计”数据更新可能会稍有延迟，请稍作等待后刷新页面查看数据是否更新。"
    }, {
      question: "分销酬金在哪里提现？",
      answer: "分销员个人中心仅展示您的“销售总金额”用作参考，具体分销酬金请联系工作人员确认提成比例后计算提成金额，并线下结算。"
    }]);
    const distributionInfo = ref(null);
    onBeforeMount(() => {
      fetch();
    });

    const fetch = () => {
      Toast.loading();
      const curUser = AV.User.current();
      const curUserInfo = curUser && curUser.toJSON();
      const {
        objectId: userObjectId,
        avatarUrl
      } = curUserInfo;
      const distributionUserQuery = new AV.Query("DistributionUser");
      const userPointer = AV.Object.createWithoutData("_User", userObjectId);
      distributionUserQuery.equalTo("user", userPointer);
      distributionUserQuery.first().then(res => {
        const distributionRes = jsonify(res);
        distributionInfo.value = distributionRes;
        distributionInfo.value.endTimeStr = dayjs(distributionInfo.value.endTime).format("YYYY年MM月DD日");
        distributionInfo.value.avatarUrl = avatarUrl;
        distributionInfo.value.dealAmountDisplay = (distributionInfo.value.dealAmount / 100).toFixed(2);
        Toast.clear();
      }).catch(err => {
        Toast.clear();
        console.error("获取分销员信息：", err);
      });
    }; // 处理分享海报弹出


    const shareImagSrc = ref("https://summit-img.geekpark.net/if2023/distribute_cover_2.png");
    const showDialog = ref(false);

    const handleShare = () => {
      console.log(distributionInfo.value.qrCode);
      Toast.loading("生成中...");

      try {
        const eleList = [{
          type: "img",
          src: distributionInfo.value.qrCode,
          left: 760,
          top: 1550,
          width: 230,
          height: 230
        }];
        shareCollectionImg("https://summit-img.geekpark.net/if2023/distribute_cover_2.png", 0, eleList, dataSrc => {
          shareImagSrc.value = dataSrc;
          Toast.clear();
          showDialog.value = true;
        });
      } catch (e) {
        Toast.clear();
      }
    }; // 关闭分享弹窗


    const closeShareImagDialog = () => {
      showDialog.value = false;
    }; // 复制优惠码


    const handleCopyCode = async () => {
      var _distributionInfo$val;

      if ((_distributionInfo$val = distributionInfo.value.promotionCode) !== null && _distributionInfo$val !== void 0 && _distributionInfo$val.objectId) {
        try {
          var _distributionInfo$val2;

          await toClipboard((_distributionInfo$val2 = distributionInfo.value.promotionCode) === null || _distributionInfo$val2 === void 0 ? void 0 : _distributionInfo$val2.objectId);
          Toast.success("复制成功");
        } catch (e) {
          Toast.fail("复制失败\n请重试");
          console.error(e);
        }
      }
    };

    return (_ctx, _cache) => {
      var _distributionInfo$val3, _distributionInfo$val4, _distributionInfo$val5, _distributionInfo$val6, _distributionInfo$val7, _distributionInfo$val8, _distributionInfo$val9, _distributionInfo$val10, _distributionInfo$val11, _distributionInfo$val12, _distributionInfo$val13, _distributionInfo$val14, _distributionInfo$val15;

      const _component_van_icon = _resolveComponent("van-icon");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(TopNavigator, {
        title: "分销员个人中心"
      }), distributionInfo.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_distributionInfo$val3 = distributionInfo.value) !== null && _distributionInfo$val3 !== void 0 && _distributionInfo$val3.avatarUrl ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        class: "user-avatar",
        src: (_distributionInfo$val4 = distributionInfo.value) === null || _distributionInfo$val4 === void 0 ? void 0 : _distributionInfo$val4.avatarUrl,
        alt: "用户头像"
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, _toDisplayString((_distributionInfo$val5 = distributionInfo.value) === null || _distributionInfo$val5 === void 0 ? void 0 : _distributionInfo$val5.name), 1)]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, _toDisplayString((_distributionInfo$val6 = distributionInfo.value) === null || _distributionInfo$val6 === void 0 ? void 0 : _distributionInfo$val6.objectId), 1)]), (_distributionInfo$val7 = distributionInfo.value) !== null && _distributionInfo$val7 !== void 0 && (_distributionInfo$val8 = _distributionInfo$val7.promotionCode) !== null && _distributionInfo$val8 !== void 0 && _distributionInfo$val8.objectId ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString((_distributionInfo$val9 = distributionInfo.value) === null || _distributionInfo$val9 === void 0 ? void 0 : (_distributionInfo$val10 = _distributionInfo$val9.promotionCode) === null || _distributionInfo$val10 === void 0 ? void 0 : _distributionInfo$val10.objectId), 1), _createElementVNode("span", {
        class: "copy-code-btn",
        onClick: handleCopyCode
      }, "复制优惠码")])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", _hoisted_15, _toDisplayString((_distributionInfo$val11 = distributionInfo.value) === null || _distributionInfo$val11 === void 0 ? void 0 : _distributionInfo$val11.endTimeStr), 1)])]), _hoisted_16, _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
        class: "operate-btn gen-cover",
        onClick: handleShare
      }, [_createVNode(_component_van_icon, {
        name: "share-o"
      }), _hoisted_18]), _createVNode(ShareBtn, {
        needWXCharge: false,
        message: `https://if.geekpark.net/home?distributionId=${distributionInfo.value.objectId}`
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_van_icon, {
          name: "link-o"
        }), _hoisted_20])]),
        _: 1
      }, 8, ["message"])]), _hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("div", _hoisted_25, _toDisplayString((_distributionInfo$val12 = distributionInfo.value) === null || _distributionInfo$val12 === void 0 ? void 0 : _distributionInfo$val12.dealAmountDisplay) + " 元", 1)]), _hoisted_26, _createElementVNode("div", _hoisted_27, [_hoisted_28, _createElementVNode("div", _hoisted_29, _toDisplayString((_distributionInfo$val13 = distributionInfo.value) === null || _distributionInfo$val13 === void 0 ? void 0 : _distributionInfo$val13.relatedUserCount), 1)]), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_32, _toDisplayString((_distributionInfo$val14 = distributionInfo.value) === null || _distributionInfo$val14 === void 0 ? void 0 : _distributionInfo$val14.dealOrderCount), 1)]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, _toDisplayString((_distributionInfo$val15 = distributionInfo.value) === null || _distributionInfo$val15 === void 0 ? void 0 : _distributionInfo$val15.dealTicketCount), 1)])]), _hoisted_36, _createElementVNode("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qas.value, qa => {
        return _openBlock(), _createElementBlock("div", {
          class: "qa-content-item",
          key: qa.question
        }, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", null, _toDisplayString(qa.question), 1)]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", null, _toDisplayString(qa.answer), 1)])]);
      }), 128))]), _createVNode(_unref(VanDialog), {
        class: "share-img-dialog",
        show: showDialog.value,
        "onUpdate:show": _cache[0] || (_cache[0] = $event => showDialog.value = $event),
        showConfirmButton: false,
        closeOnClickOverlay: true
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("img", {
          class: "share-img",
          src: shareImagSrc.value
        }, null, 8, _hoisted_43), _hoisted_44, _createVNode(_component_van_icon, {
          class: "close-share-img-icon",
          name: "close",
          color: "#fff",
          onClick: closeShareImagDialog
        })])]),
        _: 1
      }, 8, ["show"])])) : _createCommentVNode("", true)], 64);
    };
  }

};